export default "__VITE_ASSET__222f396f__"